import { useMutation } from "react-query";
import { deleteWipMeasurements } from "components/measuring/lib/measuring-data";

export const useDeleteSingleMeasurement = () => {
    return useMutation(async ({ measuringWipKey, keys }) => deleteWipMeasurements(measuringWipKey, keys[0]));
};
